import { render, staticRenderFns } from "./AddressFilialInfo.vue?vue&type=template&id=28f42929&scoped=true&"
import script from "./AddressFilialInfo.vue?vue&type=script&lang=js&"
export * from "./AddressFilialInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddressFilialInfo.vue?vue&type=style&index=0&id=28f42929&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f42929",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
